<div class="brand-search">
    <div class="greeting">
        Hi {{ firstName }} <img [src]="'svg/waveing.svg' | assetVersion" alt="Waving" class="waving-icon">
    </div>
    <div class="search-header">Choose Your Brand</div>
    <div class="info-text">
        InsightHub will show you how your brand's competitors perform and how you can outperform them
    </div>
    @if(!selectedBrand.value) {
    <div class="input-section">
        <label class="input-label">My Brand</label>
        <input
            type="text"
            class="search-input"
            [formControl]="searchControl"
            placeholder="Search for your brand"
            (focus)="onInputFocus()">
        <ng-select
            *ngIf="!showNoResults"
            [items]="brandItems"
            [formControl]="selectedBrand"
            placeholder="Search for your brand..."
            [loading]="isLoading"
            [clearable]="true"
            [searchable]="false"
            bindLabel="name"
            [compareWith]="compareBrands"
            (change)="onBrandChange($event)"
            class="brand-select brand-search-select brand-search-dropdown">
            <ng-template ng-header-tmp>
                @if (isShowingTrending) {
                    <div class="trending-header">TRENDING BRANDS</div>
                }
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
                <div class="brand-option">
                    <img [src]="(item.logoPath || 'images/no-logo.png') | assetVersion" [alt]="item.name" class="brand-icon" (error)="onIconError($event)">
                    <span>{{ item.name }}</span>
                    @if (isShowingTrending) {
                        <app-colored-chip
                            class="trending-chip"
                            backgroundColor="#EBEDEF"
                            color="#4E5258"
                            borderColor="#EBEDEF"
                            [opacity]="1"
                            text="Trending">
                        </app-colored-chip>
                    }
                </div>
            </ng-template>
            <ng-template ng-loadingtext-tmp>
                <div class="dropdown-loader">
                    <div class="spinner"></div>
                </div>
            </ng-template>
        </ng-select>
        @if(showNoResults) {
            <div class="no-results-message">
                <div class="primary-text">This brand is not included in the free trial</div>
                <div class="secondary-text">You can search for another brand to start exploring insights, or <a [href]=contactUsUrl target="_blank" rel="noopener noreferrer">contact us</a> to check availability and add your brand.</div>
            </div>
        }
    </div>
    }
    @else {
    <div class="competitors-container">
        <div class="my-brand-container">
            <label class="label">My Brand</label>
            @if(selectedBrand.value) {
                <div class="brand-item">
                    <div class="brand-left">
                        <img [src]="((selectedBrand.value.logoPath || 'images/no-logo.png') | assetVersion)" [alt]="selectedBrand.value.name" class="brand-logo" (error)="onIconError($event)">
                        <span class="brand-name">{{ selectedBrand.value.name }}</span>
                    </div>
                    <img [src]="'svg/closeX.svg' | assetVersion" alt="Clear" class="clear-icon" (click)="clearSelectedBrand()">
                </div>
            }
        </div>
        <div class="competitors-list-container">
            <label class="label">My Competitors</label>
            <div class="competitors-list">
                @if(isLoadingCompetitors) {
                    <div class="skeleton-loaders">
                        @for(skeleton of [1,2,3,4,5]; track skeleton) {
                            <div class="skeleton-loader"></div>
                        }
                    </div>
                } @else {
                    @for(competitor of competitors; track competitor.brandKey; let i = $index) {
                        <div class="brand-item">
                            <div class="brand-info">
                                <div class="competitor-number-circle">{{ i + 1 }}</div>
                                <img [src]="((competitor.logoPath || 'images/no-logo.png') | assetVersion)" [alt]="competitor.name" class="brand-logo" (error)="onIconError($event)">
                                <div class="brand-details">
                                    <span class="brand-name">{{ competitor.name }}</span>
                                    <div class="included-text">Included in your plan</div>
                                </div>
                            </div>
                        </div>
                    }
                    <img [src]="'images/no-competitors.png' | assetVersion" alt="No competitors info" class="no-competitors-image">
                }
            </div>
        </div>
    </div>
    <button class="continue-button" (click)="onContinue()" [disabled]="isSubmitting">
        @if(isSubmitting) {
            Loading...
        } @else {
            <span>Continue</span>
            <img [src]="'svg/chevron-right-white.svg' | assetVersion" alt="Continue" width="12" height="12">
        }
    </button>
    }
</div>
